import { publishQueries } from '@/entities/sets/publish';
import { useLoginStore } from '@/shared/lib/store';
import { findColor } from '@/shared/utils/publish';

export const RecentPublishedOption = ({
    onRecentOption,
    onClose,
}: {
    onRecentOption: (
        rPurpose: DATA.PurposeType,
        rGrading: DATA.GradingType,
        rPublishing: DATA.PublishingType,
        rTitle: string
    ) => void;
    onClose: () => void;
}) => {
    const { loginInfo } = useLoginStore();

    const { data } = publishQueries.publish.getRecentPublishedList({
        wrterId: loginInfo?.memberId,
    });

    const numToPurpose = (num: number) => {
        switch (num) {
            case 2:
                return 'URL';
            case 3:
                return 'output';
            default:
                return 'class';
        }
    };

    const numToGrading = (num: number) => {
        switch (num) {
            case 1:
                return 'grade';
            default:
                return 'auto';
        }
    };

    const numToPublishing = (num: number) => {
        switch (num) {
            case 2:
                return 'nickname';
            default:
                return 'class';
        }
    };

    return (
        <div className="base-box box-type">
            <div className="flex_b tableInfo">
                <p className="info">
                    * 최근 설정한 발행 옵션을 최신순으로 5개까지 확인할 수 있습니다.
                    <br />
                    발행 제목을 클릭하면 해당 발행 건의 옵션이 반영됩니다.
                </p>
            </div>
            <table className="pop_table lately_table">
                <colgroup>
                    <col width="90px" />
                    <col width="*" />
                    <col width="200px" />
                    <col width="160px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>용도</th>
                        <th>제목</th>
                        <th>발행 클래스 / 학생 수</th>
                        <th>발행일시</th>
                    </tr>
                </thead>
                <tbody>
                    {data && data?.publishList.length > 0 ? (
                        data?.publishList?.map((e, i) => (
                            <tr key={`recent-published-option-${i}`}>
                                <td className="division">
                                    {/* 과제용 blue 클래스 추가 */}
                                    <span className={findColor(e.publishUse)}>{e.publishUse}</span>
                                </td>
                                <td
                                    className="title"
                                    onClick={() => {
                                        onRecentOption(
                                            numToPurpose(e.publishType),
                                            numToGrading(e.gradingType),
                                            numToPublishing(e.publishMode),
                                            e.publishNm
                                        );
                                        onClose();
                                    }}
                                >
                                    <a href="">{e.publishNm ?? '-'}</a>
                                </td>
                                <td className="class">
                                    <ul>
                                        {e.claDetailList.map((el, il) => (
                                            <li key={`class-${il}`}>
                                                {el.claNm} / {el.trgtCnt ?? 0}명
                                            </li>
                                        ))}
                                    </ul>
                                </td>
                                <td className="date">{e.regDt ?? '-'}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={4}>최근 발행한 자료가 없습니다.</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};
